export const getTariffPrice = (
  tariff: ICourseTariff,
  value: number,
): number => {
  try {
    if (['minute', 'hour', 'month']?.includes(tariff?.type)) {
      return Number(tariff?.first_price) * value
    }
    if ('stream_custom_period' === tariff?.type) {
      return (
        tariff?.tariffPeriods?.find((item) => item.months === value)?.price ??
        Number(tariff?.first_price)
      )
    }
    return Number(tariff?.first_price)
  } catch (error) {
    return Number(tariff?.first_price)
  }
}

export const getTariffPriceWithDiscount = (
  tariff: ICourseTariff,
  value: number,
  discount?: IPromoCodeDiscount | null,
): number => {
  try {
    const currentPrice = getTariffPrice(tariff, value)
    let price = getTariffPrice(tariff, value)
    if (discount) {
      switch (discount?.type) {
        case 'percent':
          price =
            currentPrice -
            (currentPrice * Number(discount.discount)) / 100
          break
        case 'sum':
          price = currentPrice - Number(discount.discount)
          break

        default:
          price = currentPrice
      }
    } else {
      price = currentPrice
    }
    return price < 0 ? 0 : price
  } catch (error) {
    return getTariffPrice(tariff, value)
  }
}

export const getTariffOldPrice = (
  tariff: ICourseTariff,
  value: number,
): string => {
  try {
    if (tariff?.old_price === null || tariff?.old_price === '') return ''

    let oldPrice = Number(tariff?.old_price)

    if (['minute', 'hour', 'month']?.includes(tariff?.type)) {
      oldPrice = oldPrice * value
    }

    return oldPrice.toString()
  } catch (error) {
    return ''
  }
}
